module.exports = __webpack_public_path__ + "img/locker.40c1080c.svg";